module.exports = __webpack_public_path__ + "img/atom-simple.27d4ec08.svg";